import { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useReducedMotion, useSpring } from "framer-motion";

const WINE = "rgb(84, 27, 42)";

export default function MiraCursor() {
  const reduce = useReducedMotion();
  const [enabled, setEnabled] = useState(false);
  const [active, setActive] = useState(false);
  const [dark, setDark] = useState(false);
  const [hoverLink, setHoverLink] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 900, damping: 55 });
  const sy = useSpring(y, { stiffness: 900, damping: 55 });
  const last = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    const coarse = window.matchMedia("(pointer: coarse)");
    if (!mq.matches || coarse.matches) return;
    setEnabled(true);

    const detect = (cx, cy) => {
      let node = document.elementFromPoint(cx, cy);
      let isDark = false;
      while (node && node !== document.body) {
        const bg = getComputedStyle(node).backgroundColor;
        if (bg && bg !== "rgba(0, 0, 0, 0)" && bg !== "transparent") {
          isDark = bg === WINE;
          break;
        }
        node = node.parentElement;
      }
      setDark(isDark);
    };

    const move = (e) => {
      last.current = { x: e.clientX, y: e.clientY };
      x.set(e.clientX + 16);
      y.set(e.clientY + 16);
      setActive(true);
      document.body.classList.add("custom-cursor");
      detect(e.clientX, e.clientY);
      setHoverLink(!!e.target.closest("a, button"));
    };
    const onScroll = () => detect(last.current.x, last.current.y);

    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("scroll", onScroll);
      document.body.classList.remove("custom-cursor");
    };
  }, [x, y]);

  if (!enabled) return null;

  const color = dark ? "#F4F0E7" : "#541B2A";
  const ring = hoverLink ? "#C7F000" : color;

  return (
    <motion.div
      data-testid="mira-cursor"
      aria-hidden="true"
      className="pointer-events-none fixed left-0 top-0 z-[60]"
      style={{ x: reduce ? x : sx, y: reduce ? y : sy }}
      animate={{ opacity: active ? 1 : 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="h-6 w-6 rounded-full border"
        animate={{ scale: hoverLink ? 1.7 : 1, borderColor: ring }}
        transition={{ duration: 0.25, ease: "easeOut" }}
      />
      <p
        className="mt-2 text-[10px] uppercase tracking-[0.3em] transition-colors duration-300"
        style={{ color }}
      >
        mira
      </p>
    </motion.div>
  );
}
